const URLS = {
  login: '/login',
  register: '/register',
  menu: '/menu',
  languages: '/languages',
  banners: '/banners',
  // New individual endpoints for better performance
  // Note: Backend uses menu_id in URLs, frontend needs to get user menu first
  getAllCategories: (menuId) => `/get-all-categories/${menuId}`,
  getAllSubcategories: (menuId) => `/get-all-subcategories/${menuId}`,
  getAllBrands: (menuId) => `/get-all-brands/${menuId}`,
  getAllProducts: (menuId) => `/get-all-products/${menuId}`,
  searchProducts: (menuId) => `/search-products/${menuId}`,
  staffProductSearch: () => '/products/staff-search',
  bulkProductOperations: () => '/products/bulk-operations',
  bulkProductOperationsDryRun: () => '/products/bulk-operations/dry-run',
  productDetails: (productId) => `/product/${productId}`,
  categoryDetails: (categoryId) => `/category/${categoryId}`,
  subcategoryDetails: (subcategoryId) => `/subcategory/${subcategoryId}`,
  brandDetails: (brandId) => `/brand/${brandId}`,
  home: '/home',
  createTag: '/create-tag',
  getTagImage: ({ tagId }) => `/files/tag-images/${tagId}`,
  getTag: ({ tagId }) => `/tag/${tagId}`,
  createCategory: '/create-category',
  uploadCategoryImage: ({ categoryId }) => `/category/${categoryId}/image`,
  uploadCategoryThumbnailImage: ({ categoryId }) => `/category/${categoryId}/thumbnail-image`,
  uploadTagImage: ({ tagId }) => `/tag/${tagId}/image`,
  uploadProductImage: ({ productId }) => `/product/${productId}/image`,
  deleteCategory: ({ categoryId }) => `/delete-category/${categoryId}`,
  deleteTag: ({ tagId }) => `/delete-tag/${tagId}`,
  getCategoryImage: ({ categoryId }) => `/files/category-images/${categoryId}`,
  getProduct: ({ productId }) => `/product/${productId}`,
  createProduct: ({ categoryId }) => `/create-product/${categoryId}`,
  updateProduct: ({ productId }) => `/product/${productId}`,
  updateProductDiscount: ({ productId }) => `/product/${productId}/discount`,
  bulkUpdateProductDiscount: `/products/bulk-discount`,
  removeProductDiscounts: `/products/remove-discounts`,
  updateCategory: ({ categoryId }) => `/category/${categoryId}`,
  updateTag: ({ tagId }) => `/tag/${tagId}`,
  deleteProductFetch: ({ productId, categoryId }) =>
    `category/${categoryId}/delete-product/${productId}`,
  getProductImage: ({ productId }) => `/files/product-images/${productId}`,
  updateProductTranslation: ({ productTranslationId }) =>
    `/product-translations/${productTranslationId}`,
  updateCategoryTranslation: ({ categoryTranslationId }) =>
    `/category-translations/${categoryTranslationId}`,
  updateTagTranslation: ({ tagTranslationId }) => `/tag-translations/${tagTranslationId}`,
  addCategoryToTag: ({ tagId }) => `/tag/${tagId}/add-category`,
  categoryPrioritiesUpdate: '/category-priorities/',
  subcategoryPrioritiesUpdate: '/subcategory-priorities/',
  brandPrioritiesUpdate: '/brand-priorities/',
  productPrioritiesUpdate: ({ categoryId }) => `/product-priorities/${categoryId}`,
  deleteSubcategory: ({ subcategoryId }) => `/delete-subcategory/${subcategoryId}`,
  createSubcategory: ({ categoryId }) => `/create-subcategory/${categoryId}`,
  updateSubcategory: ({ subcategoryId }) => `/subcategory/${subcategoryId}`,
  uploadSubcategoryImage: ({ subcategoryId }) => `/subcategory/${subcategoryId}/image`,
  getSubcategoryImage: ({ subcategoryId }) => `/files/subcategory-images/${subcategoryId}`,
  productPrioritiesForSubcategoryUpdate: ({ subcategoryId }) =>
    `/subcategory-product-priorities/${subcategoryId}`,
  deleteBrand: ({ brandId }) => `/delete-brand/${brandId}`,
  createBrand: () => `/create-brand`,
  updateBrand: ({ brandId }) => `/brand/${brandId}`,
  uploadBrandImage: ({ brandId }) => `/brand/${brandId}/image`,
  getBrandImage: ({ brandId }) => `/files/brand-images/${brandId}`,
  productPrioritiesForBrandUpdate: ({ brandId }) => `/brand-product-priorities/${brandId}`,
  whatsappSendMarketingMessage: () => `/whatsapp/send-marketing-message`,
  manageBannerImages: () => `/banner/manage-images`,
  manageProductImages: productId => `/product/${productId}/manage-images`,
  getCoupons: () => `/coupons`,
  getCoupon: ({ couponId }) => `/coupons/${couponId}`,
  createCoupon: () => `/coupons`,
  updateCoupon: ({ couponId }) => `/coupons/${couponId}`,
  deleteCoupon: ({ couponId }) => `/coupons/${couponId}`,
  userSettings: '/user/settings',
  orders: '/orders',
  getNotifications: ({ menuId }) => `/notifications?menu_id=${menuId}`,
  createNotification: () => `/notifications`,
  // Search endpoints
  searchCategories: () => `/search-categories`,
  searchSubcategories: () => `/search-subcategories`,
  searchBrands: () => `/search-brands`,
  getAllAddons: (menuId) => `/get-all-addons/${menuId}`,
  searchAddons: () => `/search-addons`,
  addonDetails: (addonId) => `/addon/${addonId}`,
  createAddon: () => `/create-addon`,
  updateAddon: ({ addonId }) => `/addon/${addonId}`,
  deleteAddon: ({ addonId }) => `/delete-addon/${addonId}`,
  uploadAddonImage: ({ addonId }) => `/addon/${addonId}/image`,
  getAddonImage: ({ addonId }) => `/files/addon-images/${addonId}`,
  pricingTiers: () => `/pricing-tiers`,
  pricingTier: ({ tierId }) => `/pricing-tiers/${tierId}`,
  searchPricingTierProducts: ({ tierId }) => `/pricing-tiers/${tierId}/products/search`,
  updatePricingTierProductOverrides: ({ tierId, productId }) => `/pricing-tiers/${tierId}/products/${productId}/overrides`,
  menuEventsOutbox: () => `/menu-events/outbox`,
  downloadProductsExport: ({ userId }) => `/download-excel/${userId}`,
};

export default URLS;
